/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Fix_Deck_BtnInputs */



/**
* | output |
* | --- |
* | "Fix your deck" |
*
* @param {Tournament_Fix_Deck_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_fix_deck_btn = /** @type {((inputs?: Tournament_Fix_Deck_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Fix_Deck_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger votre deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corrija su deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Corrija seu deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi il tuo deck")
	return /** @type {LocalizedString} */ ("Fix your deck")
});